import React from "react";
import { CKEditor } from "@ckeditor/ckeditor5-react/dist/index";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic/build/ckeditor";
import "./style.scss";

interface CKeditorProps {
  onChange: (data: string) => void;
  editorLoaded: boolean;
  value: string;
  minLength?: number;
}

export default function CKeditor({
  onChange,
  editorLoaded,
  value,
  minLength,
}: CKeditorProps) {
  return (
    <div>
      {editorLoaded ? (
        <CKEditor
          editor={ClassicEditor}
          config={{
            toolbar: {
              items: [
                "heading",
                "|",
                "bold",
                "italic",
                "link",
                "bulletedList",
                "numberedList",
                "selectAll",
                "|",
                "outdent",
                "indent",
                "|",
                "blockQuote",
                "insertTable",
                "|",
                "undo",
                "redo",
              ],
            },
            language: "fa",
            table: {
              contentToolbar: [
                "tableColumn",
                "tableRow",
                "mergeTableCells",
                "tableCellProperties",
              ],
            },
          }}
          data={value}
          onChange={(event: any, editor: any) => {
            const data = editor.getData();
            onChange(data);
          }}
        />
      ) : (
        <div>Editor loading</div>
      )}
    </div>
  );
}
